import {Component, Input, OnChanges, OnInit} from '@angular/core';
import { RecentActivity } from './recent-activity.model';


@Component({
  selector: 'app-widget-recent-activity',
  templateUrl: './recent-activity.component.html',
  styleUrls: ['./recent-activity.component.scss'],
  standalone: false
})
export class RecentActivityComponent implements OnInit, OnChanges {

  @Input() recentActivities: RecentActivity[] = [];
  @Input() height = 0;
  @Input() searchText: string;

  private deletedHeaderIds: Set<string> = new Set();

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    this.updateDeletedHeaderIds();
  }

  private updateDeletedHeaderIds(): void {
    this.deletedHeaderIds.clear();
    if (this.recentActivities) {
      for (const activity of this.recentActivities) {
        if (activity.message?.toUpperCase().includes('DELETED') && activity.header_id) {
          this.deletedHeaderIds.add(activity.header_id);
        }
      }
    }
  }

  isDeleted(headerId: string | undefined): boolean {
    return !!headerId && this.deletedHeaderIds.has(headerId);
  }

}
